import { apiClient } from './api'

export interface Treatment {
  id: string
  yardId: string | number
  treatmentType: string
  treatmentDate: string
  notes?: string
  createdAt?: string
}

export interface CreateTreatmentPayload {
  yardId: string | number
  treatmentType: string
  treatmentDate: string
  recipeId?: number
  notes?: string
  userId?: string | number
}

/**
 * Gets treatments
 * @param params - Query params
 * @returns Promise with treatment list
 */
export function getTreatments(params?: { yardId?: string | number }) {
  return apiClient.get<Treatment[]>('/treatments', { params })
}

/**
 * Creates a new treatment
 * @param payload - Treatment payload
 * @returns Promise with treatment
 */
export function createTreatment(payload: CreateTreatmentPayload) {
  return apiClient.post<Treatment>('/treatments', payload)
}
